<template>
    <div class="contentWrapper">
        <div class="contentBlock">
            <h3>{{$t('authors.title')}}</h3>






                <div class="authorsWrap">
                    <div class="authorBlock" v-for="author in this.authors" :style="{ 'background-image': 'url(http://mod.worms.pro/resources/ava/' + author.avatar + '.jpg)' }" v-bind:data-tooltip="$t('authors.text' +  author.name)">
                        <p class="title">
                            {{$t('authors.name' + author.name)}}
                        </p>
                        <p class="subtitle" @click="GoContent(author.name)">{{$t('text.ButtonReadMore')}}</p>
                    </div>                 
                </div>

            <h3>{{$t('authors.testers')}}</h3>






                <div class="authorsWrap">
                    <div class="testerBlock" v-for="tester in this.testers" v-bind:data-tooltip="$t('authors.testing')">
                            {{$t('authors.name' + tester.name)}}
                    </div>                 
                </div>







            
        </div>
    </div>
</template>

<script>
export default {
    name: 'Authors',
    data: () => ({

        authors: [
            {
                name: 'Firsacho',
                avatar: '855762'
            },
            {
                name: '4erver',
                avatar: '783331'
            }, 
            {
                name: 'PROFILE',
                avatar: '4541-043448'
            }, 
            {
                name: 'SW_Krash',
                avatar: '1972-129438'
            },  
            {
                name: 'Agent007',
                avatar: '767128'
            },  
            {
                name: 'PrIzRaK',
                avatar: '284036'
            },  
            {
                name: 'Vorobey',
                text: '',
                avatar: '602129'
            },  
            {
                name: 'Unaited',
                avatar: '974937'
            },  
            {
                name: 'Nezon',
                avatar: '0497-508500'
            },  
            {
                name: 'vera34',
                avatar: '580683'
            },  
            {
                name: 'Emishka',
                avatar: 'emishka'
            },
            {
                name: 'Zelenium',
                avatar: 'zelenium'
            },
            {
                name: 'Master_Erdees',
                avatar: 'master'
            },            
            {
                name: 'Quete',
                avatar: '3352-606382'
            },  
            {
                name: 'Sergey',
                avatar: '497197'
            },  
            {
                name: 'Lemur',
                avatar: '2204-429148'
            },  
            {
                name: 'Egokarpo',
                avatar: 'no_avatar'
            },  
            {
                name: 'Skript47',
                text: '',
                avatar: 'no_avatar'
            },  
            {
                name: 'Woitek',
                avatar: '5311-327590'
            },  
            {
                name: 'Lex_Serest',
                avatar: 'tumblr_inline_ne2bnsjzI41qfq25i'
            },  
            {
                name: 'Symbianer',
                avatar: '5624-215077'
            },  
            {
                name: 'KaMiKaZe',
                avatar: '141132'
            },  
            {
                name: 'JMOT',
                avatar: '006823'
            },
        ],
        testers: [  
            {
                name: 'Emishka'
            },  
            {
                name: 'Lord_Syntesys'
            },  
            {
                name: 'Joker'
            }            
        ]
    }),
    methods: {
        NewTabUrlOpen(val){
            window.open(val, '_blank')
        },
		GoContent(val){
			this.$router.push('/content/'+val.toLowerCase())
		},
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btnDiscordLayout {
    margin-bottom: 5px;
}
.authorsWrap {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-pack: justify;
    justify-content: space-around;
}
.authorBlock {
    position: relative;
    height: 218px;
    width: 150px;
    margin: 10px 5px;
    background-color: #222;
    background-image: url('http://mod.worms.pro/ava/855762.jpg');
    background-size: 150px auto;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 3px; 
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);     
}
.authorBlock:hover {
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
}
.authorBlock .subtitle {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    margin: 0;
    background-color: #4a76a8;
    height: 34px;
    color: #fff;
    font-weight: bold;
    line-height: 34px;
    text-align: center;
    text-indent: 0px;
}
.authorBlock .title {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;  
    background-color: #fff;
    height: 34px;
    font-weight: bold;
    line-height: 34px;
    text-align: center;
    text-indent: 0px;
}

.testerBlock {
    position: relative;
    height: 34px;
    width: 150px;
    margin: 10px 5px;
    background-color: #fff;
    font-weight: bold;
    line-height: 34px;
    text-align: center;
    text-indent: 0px;
    border-radius: 3px; 
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);    
}

**
 * Tooltip Styles
 */

/* Add this attribute to the element that needs a tooltip */
[data-tooltip] {
  position: relative;
  z-index: 2;
  cursor: pointer;
}

/* Hide the tooltip content by default */
[data-tooltip]:before,
[data-tooltip]:after {
  visibility: hidden;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: progid: DXImageTransform.Microsoft.Alpha(Opacity=0);
  opacity: 0;
  pointer-events: none;
}

/* Position tooltip above the element */
[data-tooltip]:before {
  position: absolute;
  bottom: 101%;
  left: 50%;
  margin-bottom: 5px;
  margin-left: -90px;
  padding: 4px;
  width: 180px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  background-color: #000;
  background-color: hsla(0, 0%, 20%, 0.9);
  color: #fff;
  content: attr(data-tooltip);
  text-align: center;
  font-size: 14px;
  line-height: 1.15;
}

/* Triangle hack to make tooltip look like a speech bubble */
[data-tooltip]:after {
  position: absolute;
  bottom: 101%;
  left: 50%;
  margin-left: -5px;
  width: 0;
  border-top: 5px solid #000;
  border-top: 5px solid hsla(0, 0%, 20%, 0.9);
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  content: " ";
  font-size: 0;
  line-height: 0;
}

/* Show tooltip content on hover */
[data-tooltip]:hover:before,
[data-tooltip]:hover:after {
  visibility: visible;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: progid: DXImageTransform.Microsoft.Alpha(Opacity=100);
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/Authors.vue